import { render, staticRenderFns } from "./discountEditor.vue?vue&type=template&id=ed7a1fee&scoped=true"
import script from "./discountEditor.vue?vue&type=script&lang=js"
export * from "./discountEditor.vue?vue&type=script&lang=js"
import style0 from "./discountEditor.vue?vue&type=style&index=0&id=ed7a1fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7a1fee",
  null
  
)

export default component.exports